/**
 * @module 同居家族削除確認ダイアログコンポーネント
 */
export default {
  name: 'DeleteConfirmModal',
  props: ['person', 'dialog', 'relationship', 'sortFlag'],
  data() {
    return {
      childDialog: this.dialog,
      childPerson: this.person,
      childRelationship: this.relationship,
    };
  },
  computed: {},
  /** @type {Methods} */
  methods: {
    /**
     * ダイアログを閉じる処理
     */
    closeModal() {
      this.childDialog = false;
    },
    /**
     * はいボタン押下時処理呼び出し処理
     */
    deletePerson() {
      this.$emit('delete-person', this.childPerson.id);
      this.childDialog = false;
    },
  },
};
